export function objCompare (prop) {
  return function (obj1, obj2) {
    if (prop) {
      return obj1[prop] - obj2[prop]
    }
  }
}

export function valCompare (val1, val2) {
  return val1 - val2
}

export function objKeySort (obj) {
  let newkey = Object.keys(obj).sort()
  let newObj = {}
  for (let i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]]
  }
  return newObj
}



// WEBPACK FOOTER //
// ./src/api/js/compare.js